import { render, staticRenderFns } from "./SortAndFilterTool.vue?vue&type=template&id=c8c733be&scoped=true&"
import script from "./SortAndFilterTool.vue?vue&type=script&lang=js&"
export * from "./SortAndFilterTool.vue?vue&type=script&lang=js&"
import style0 from "./SortAndFilterTool.vue?vue&type=style&index=0&id=c8c733be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c733be",
  null
  
)

export default component.exports